import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');
export default class ManageContact extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
// 				let parms = JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
//         console.log("parms => " + parms);

let parms ='';
		this.state={
			"contact" : {
				"contactsId": JSON.parse(parms).id,
				"contactsOwnerId":0,
				"contactName":"",
				"address1":"",
				"address2":"",
				"city":"",
				"stateCode":0,
				"postalCode":"",
				"countryCode":0,
				"homePhone":"",
				"cellPhone":""
				,"workPhone":"",
				"faxPhone":"",
				"otherPhone1":"",
				"otherPhone2":"",
				"otherPhone3":"",
				"otherPhone4":"",
				"otherPhone5":"",
				"email1":"",
				"email2":"",
				"email3":"",
				"email4":"",
				"email5":"",
				"im1":"",
				"im2":"",
				"im3":"",
				"im4":"",
				"im5":"",
				"firstName":"",
				"lastName":"",
				"middleInitial":false,
				"titleCode":0,
				"suffixCode":0,
				"contactNickname":"",
				"birthday":"",
				"description":"",
				"jobTitle":"",
				"companyName":"",
				"pictureFilepath":"",
				"createUser":0,
				"createDate":"",
				"lastUpdateUser":0,
				"lastUpdateDate":"",
				"province":"",
				"website":"",
				"intlPhone":"",
				"client":"",
				"optInOut":"",
				"notes":"",
				"affiliations":"",
				"provinceCode":0,
				"contactTypeCode":0,
				"relationshipTypeCode":0,
				"relationshipOwnerId":0,
				"activeFlag":false,
				"userDefined":"",
				"salesStepCode":0,
				"interests":"",
				"fundingPotential":"",
				"history":"",
				"approached":"",
				"lastContact":"",
				"inhouseContact":"",
				"assistantsName":"",
				"spousesName":"",
				"keyPlayer":"",
				"referredBy":"",
				"finder":"",
				"nextActions":"",
				"initialContact":"",
				"emailedLink":"",
				"executiveSummary":"",
				"electronicKit":"",
				"mailedKit":"",
				"meetingDate":"",
				"fullDemo":"",
				"sentPpmNo":"",
				"dollarsAsk":0,
				"dollarsSoft":0,
				"dollarsCommitted":0,
				"priority":0,
				"reasonInvestHelp":"",
				"howTheyCanHelp":"",
				"source":"",
				"reviewWith":"",
				"followUpStatus":"",
				"webSubject":"",
				"webMessage":"",
				"contentId":0,
				"securityContextId":0,
				"clientContact":"",
				"listHeaderId":0,
				"contactNumber":"",
				"sourceFilepath":"",
				"nickname":"",
				"middleName":"",
				"ethnicityCode":0,
				"sourceDatabase":"",
				"mediaOutlet":"",
				"marketId":0,
				"genderCode":0,
				"raceCode":0,
				"primaryLanguageCode":0,
				"numGuests":0,
				"radioSpecFlag":false,
				"syndicatorFlag":false,
				"dayPhone":"",
				"eveningPhone":"",
				"listCategoryId":0,
				"stateName":"",
				"listCategoryName":"",
				"industryCode":0,
				"mailingAddressId":0,
				"mailingSicCode":0,
				"mailingMsaCode":0,
				"locationId":0,
				"dAndBScore":0,
				"companyTypeCode":0,
				"opportunityName":"",
				"opportunityValue":0,
				"salesStageCode":0,
				"statusCode":0,
				"weight":0,
				"weightedValue":0,
				"dateEntered":"",
				"dateClosed":"",
				"departmentCode":0,
				"probability":0,
				"dunsNumber":"",
				"mailingAddress1":"",
				"mailingAddress2":"",
				"mailingCity":"",
				"mailingStateCode":0,
				"mailingPostalCode":"",
				"mailingProvince":"",
				"mailingCountryCode":0,
				"revenueMils":0,
				"numEmployees":0
			},
			contactStatusCodeList : []
			
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({
			[target.id] : target.value
		});
	   
		console.log(this.state);
	  }
	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	
	  var url = `${global.config.apiServicesUrl}/contacts`;
//	  var idUrl = "${global.config.securityServicesUrl}/next-id-generator/get-next/contacts/contactsId";
	
//	  axios.get(idUrl)
//		  .then(response => {
//			  this.setState({generalledgerId : response.data["nextId"]});
//		  
//			  //console.log("new category id = " + JSON.stringifyt(this.state.contact.contentCategoriesObject.contentCategoryId));
//		
//			console.log("request object = " + JSON.stringify(this.state));
	  		this.state.contact.lastUpdateUser = Number(this.props.userId);

			axios
			  .post(url, this.state)
			  .then(response2 => {
			console.log("response.data");
			console.log(response2.status +":"+response2.data.accountId);
			// && response2.data.contentFacadeId === this.state.contact.contentFacadeId
			if (response2.status === 200 )
			{
				this.message = "Success";
			}
			else
			{
				 this.message = "Failed";
			}        
			console.log(this.message);
			 // 
			event.preventDefault();
			//response.send(this.message);
			
		  })
			  .catch(err => {
			 console.log("error - " + err);
		  });
			  console.log("message info - " + this.message); 
		this.handleClear();
			
		//});
		
		
			console.log("SetState Message info-"+this.contentFacadeTypeId);
			console.log("SetState Message info-"+this.contentFacadeName);
			
	 };
	 handleClear(){
		 this.setState({contact : {}})
	 }
	 componentDidMount() 
	 {
	 	this.handleOnLoad();
	 }

	handleOnLoad = () => {
		 this.setState({contact : {}});
		 
 			//resolve drop down lists
			{
				//taskPriorityList
				var url1 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/RESOURCE_ROLE_STATUS`;
					axios.get(url1)
					.then(response =>{
 					this.setState({contactStatusCodeList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
			}			 
	 }
	
	render(){
    return (
        				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
		
		<form>
		<div class="container-fluid">
		<h4>Create Contact</h4>
		<hr />
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Contact Name</label>
		<input id="contactName" class="form-control input-medium col-sm-8" value={this.state.contact.contactName} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Company</label>
		<input id="ownerUserId" class="form-control input-medium col-sm-8" value={this.state.contact.companyName} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Address </label>
		<input id="projectId" class="form-control input-medium col-sm-8" value={this.state.contact.address1} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Address</label>
		<input id="desktopId" class="form-control input-medium col-sm-8" value={this.state.contact.address2} onChange ={this.handleChange}/>
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >City</label>
		<input id="contentId" class="form-control input-medium col-sm-8" value={this.state.contact.city} onChange ={this.handleChange}/>
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >State</label>
		<input id="contentId" class="form-control input-medium col-sm-8" value={this.state.contact.stateCode} onChange ={this.handleChange}/>
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Postal Code</label>
		<input id="contentId" class="form-control input-medium col-sm-8" value={this.state.contact.postalCode} onChange ={this.handleChange}/>
		</div>

			<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Status</label>
			<select id="contactStatusCode" class="form-control input-medium col-sm-8" value={this.state.contact.statusCode} onChange ={this.handleChange}>
			{
				this.state.contactStatusCodeList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Description</label>
			<input id="contactDescr" class="form-control input-medium col-sm-8" value={this.state.contact.description} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Cell Phone</label>
			<input id="contactEntry" class="form-control input-medium col-sm-8" value={this.state.contact.cellPhone} onChange ={this.handleChange}/>
			</div>

		

				<hr/>
							<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Created By</label>
		<input id="createUserName" class="form-control input-medium col-sm-2" value={this.state.createUserName} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="createDate" class="form-control input-medium col-sm-2" value={String(this.state.contact.createDate).substring(0,10)} />
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Last Updated By</label>
		<input id="lastUpdateUserName" class="form-control input-medium col-sm-2" value={this.state.lastUpdateUserName} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="lastUpdateDate" class="form-control input-medium col-sm-2" value={String(this.state.contact.lastUpdateDate).substring(0,10)} />
		</div>
		<hr />	
					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Create" onClick ={this.handleSubmit}>Create</button>&nbsp;
		</div>		
		</form>
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
	);
}
}